export default {
  primary: {
    50: '#ECFFFD',
    100: '#BDFFFD',
    200: '#7BFFFC',
    300: '#31FFFD',
    400: '#00FFF3',
    500: '#00EDDA',
    600: '#00BFB5',
    700: '#009791',
    800: '#007775',
    900: '#00615F',
    950: '#003C3D',
  },
  green: {
    50: '#EEFBF3',
    100: '#D5F6DF',
    200: '#AEECC3',
    300: '#67D695',
    400: '#44C37D',
    500: '#21A861',
    600: '#13884E',
    700: '#0F6D40',
    800: '#0F5635',
    900: '#0D472D',
    950: '#06281A',
  },
  red: {
    50: '#FFF2F1',
    100: '#FFE2E1',
    200: '#FFC9C7',
    300: '#FFA4A0',
    400: '#FF7973',
    500: '#F8433B',
    600: '#E5261D',
    700: '#C11B14',
    800: '#A01A14',
    900: '#841D18',
    950: '#480A07',
  },
  orange: {
    50: '#FFF9ED',
    100: '#FFF2D5',
    200: '#FFDB99',
    300: '#FFCA72',
    400: '#FDA83A',
    500: '#FC8D13',
    600: '#ED7009',
    700: '#C4550A',
    800: '#9C4310',
    900: '#7D3811',
    950: '#441B06',
  },
  yellow: {
    50: '#FEFEE8',
    100: '#FFFEC2',
    200: '#FFFB9B',
    300: '#FFF045',
    400: '#FCE013',
    500: '#ECC706',
    600: '#CC9B02',
    700: '#A26F06',
    800: '#86570D',
    900: '#724711',
    950: '#432505',
  },
  blue: {
    50: '#F2FAFD',
    100: '#DCEEF7',
    200: '#C5E6F2',
    300: '#92D2E7',
    400: '#58BAD8',
    500: '#32A1C5',
    600: '#2383A6',
    700: '#1D6887',
    800: '#1C5970',
    900: '#1C4A5E',
    950: '#13303E',
  },
  beige: {
    50: '#F9F3F0',
    100: '#F3E7E1',
    200: '#E6CDC2',
    300: '#D6AC9B',
    400: '#C48573',
    500: '#B86957',
    600: '#AB574B',
    700: '#8E4640',
    800: '#733A39',
    900: '#5E3230',
    950: '#321818',
  },
  greyscale: {
    50: '#F7F8F8',
    100: '#EEF0F0',
    200: '#DEE3E3',
    300: '#B7C2C2',
    400: '#90A0A0',
    500: '#728584',
    600: '#5C6D6D',
    700: '#4B5959',
    800: '#414B4B',
    900: '#394141',
    950: '#262B2B',
  },
};
